import { useIntl } from 'react-intl';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import { Rule, FormItemProps } from 'antd/lib/form';

import FloatingFormItem from '../FloatingFormItem';

const plateMask = [
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
  /[A-Za-z0-9]/,
];

interface LicensePlateFormFieldProps extends FormItemProps {
  requiredRuleTextId?: string;
  lengthRuleTextId?: string;
  required?: boolean;
  disabledFields?: boolean;
  maskedInputProps?: Omit<MaskedInputProps, 'mask'>;
}

function LicensePlateFormField({
  requiredRuleTextId = 'commons.form.errors.requiredLicensePlate',
  lengthRuleTextId = 'commons.form.errors.invalidLicensePlate',
  required = true,
  disabledFields,
  ...props
}: LicensePlateFormFieldProps) {
  const intl = useIntl();

  let rules: Rule[] = [
    {
      min: 1,
      max: 7,
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ];

  if (required) {
    rules = [
      {
        required: true,
        message: intl.formatMessage({ id: requiredRuleTextId }),
      },
      ...rules,
    ];
  }

  if (props.rules?.length) {
    rules = [...rules, ...props.rules];
  }

  return (
    <FloatingFormItem
      {...props}
      getValueFromEvent={({ target }) => {
        const value = String(target.value).toUpperCase();
        if (props.getValueFromEvent) {
          return props.getValueFromEvent(value);
        }
        return value;
      }}
      rules={rules}
    >
      <MaskedInput
        className="ant-input"
        mask={plateMask}
        guide={false}
        disabled={disabledFields}
        {...props.maskedInputProps}
      />
    </FloatingFormItem>
  );
}

export default LicensePlateFormField;
